import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { ActionSearch } from "../../../../store/slices/search/actions";
import { selectTaps } from "../../../../store/slices/search/selectors";
import { ChipsBlock } from "./ChipsBlock";
var mapStateToProps = function mapStateToProps(state) {
  var _selectTaps;
  return {
    taps: selectTaps(state),
    shouldRender: !!((_selectTaps = selectTaps(state)) !== null && _selectTaps !== void 0 && _selectTaps.length)
  };
};
var mapDispatchToProps = {
  onSearch: ActionSearch.fetchSearchDataWithTabs
};
export var ChipsBlockRC = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(ChipsBlock);